import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dashboardAPI as apiConfig } from '../../../axiosConfig';

const URL = '/errorconfig';

const SLICE_NAME = 'errorConfig';
const ERROR_CONFIG_LIST = SLICE_NAME + '/list';
const ERROR_CONFIG_ADD = SLICE_NAME + '/add';
const ERROR_CONFIG_UPDATE = SLICE_NAME + '/{id}/update';
const ERROR_CONFIG_DELETE = SLICE_NAME + '/{id}/delete';
const ERROR_CONFIG_INVALIDATE_CACHE = SLICE_NAME + '/invalidateCache';

export const getErrorConfigList = createAsyncThunk(
  ERROR_CONFIG_LIST,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.get(URL);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const addErrorConfig = createAsyncThunk(
  ERROR_CONFIG_ADD,
  async ({ payload, headers }, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.post(URL, payload, {
        headers,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const updateErrorConfig = createAsyncThunk(
  ERROR_CONFIG_UPDATE,
  async ({ payload, id, headers }, { rejectWithValue }) => {
    const url = `${URL}/${id}`;

    try {
      const { data } = await apiConfig.put(url, payload, {
        headers,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const deleteErrorConfig = createAsyncThunk(
  ERROR_CONFIG_DELETE,
  async ({ id, headers }, { rejectWithValue }) => {
    const url = `${URL}/${id}`;

    try {
      const { data } = await apiConfig.delete(url, {
        headers,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const invalidateCache = createAsyncThunk(
  ERROR_CONFIG_INVALIDATE_CACHE,
  async (_, { rejectWithValue }) => {
    const url = `${URL}/invalidatecache`;

    try {
      const { data } = await apiConfig.get(url);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const errorConfigSlice = createSlice({
  name: SLICE_NAME,
  initialState: {
    list: [],
    listStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed',
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getErrorConfigList.pending, (state) => {
        state.listStatus = 'loading';
      })
      .addCase(getErrorConfigList.rejected, (state) => {
        state.list = [];
        state.listStatus = 'failed';
      })
      .addCase(getErrorConfigList.fulfilled, (state, { payload }) => {
        state.list = payload;
        state.listStatus = 'succeeded';
      });
  },
});

export const errorConfigActions = errorConfigSlice.actions;

export const selectIsLoadingErrorConfigList = (state) =>
  state.errorConfig.listStatus === 'loading';

export const selectErrorConfigList = (state) => state.errorConfig.list;

export default errorConfigSlice.reducer;
